import styled from "styled-components";

export const FilterSelectWrapper = styled.div`
  position: relative;

  // NOTE: 'Publication Number'처럼 긴 라벨이 고정폭(10.4rem) pill을 넘치지 않도록 내용에 맞게 확장
  button > div {
    width: auto;
    min-width: 10.4rem;
  }
`;

export const SelectButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  > img {
    margin-left: 0.6rem;
  }
`;

export const FilterListTitle = styled.p`
  display: flex;
  align-items: center;
  height: 1.6rem;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 145%;
  color: #2a2f37;
`;

export const DropDown = styled.ul`
  display: flex;
  position: absolute;
  flex-direction: column;
  z-index: 20;
  gap: 0.4rem;
  width: max-content;
  min-width: 12rem;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.color.neural.gray05};
  border-radius: 0.4rem;
  padding: 0.8rem;
  margin-top: 0.4rem;

  // NOTE: 모든 옵션 pill을 가장 긴 라벨 폭으로 통일 (드롭다운은 max-content, 옵션은 100%로 채움)
  li,
  li button,
  li button > div {
    width: 100%;
  }
`;
